import * as React from 'react'
import { SVGProps } from 'react'
const SvgOutlet = (props: SVGProps<SVGSVGElement>) => (
  <svg id="Layer_2" viewBox="0 0 21.14 21.11" {...props}>
    <defs>
      <style>{'.cls-1{fill:none;stroke:#000;stroke-miterlimit:10}'}</style>
    </defs>
    <g id="Layer_1-2">
      <path
        className="cls-1"
        d="M19.94 9.66 9.26 20.34c-.35.35-.92.36-1.26.02L.75 13.12a.888.888 0 0 1 .02-1.26L11.5 1.13c.44-.44 1.03-.67 1.64-.62s1.24.13 1.93.28c1.35.29 2.48.73 3.35 1.16.33.16.59.42.75.74.37.72.75 1.63 1.04 2.72.24.89.36 1.71.42 2.43.06.68-.2 1.35-.7 1.84Z"
      />
      <circle className="cls-1" cx={15.23} cy={5.52} r={1.58} />
    </g>
  </svg>
)
export default SvgOutlet
